module.exports = __webpack_public_path__ + "img/instructions-2.8da6ac47.png";